import React from 'react';
import {
  StyledEarningsTable,
  RowColumnColor,
  HeadColumnColor,
  SmallText,
  SmallTexts
} from './styled';

const EarningsTable = () => {
  const renderCellInHead = (content) => (
    <th>
      <HeadColumnColor>{content}</HeadColumnColor>
    </th>
  );

  const renderCellInRow = (content) => (
    <td>
      <RowColumnColor>{content}</RowColumnColor>
    </td>
  );
  return (
    <>
      <StyledEarningsTable>
        <thead>
          <tr>
            <th> </th>
            <th>
              <HeadColumnColor>Ambassador fee</HeadColumnColor>
            </th>
            {renderCellInHead('Purchases (standard)')}
            {renderCellInHead('Payouts per year')}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Nomad insurance</td>
            {renderCellInRow('10%')}
            {renderCellInRow('10*')}
            {renderCellInRow('$480')}
          </tr>
        </tbody>
      </StyledEarningsTable>
      <SmallTexts>
        <SmallText>
          *10 Affiliate Purchases for 1 person with no add-ons and an annual subscription
          (optional).
        </SmallText>
      </SmallTexts>
    </>
  );
};

export default EarningsTable;
